<template>
  <div>
    <b-modal
      :id="'profile-modal' + modalIdKey"
      v-model="profileModalVisible"
      hide-footer
      no-close-on-backdrop
      scrollable
      centered
      modal-class="modal-global layout-modal-640"
      header-class="w-100 clear-border pb-0 pt-19 px-18"
      body-class="text-left px-33 pb-80 clear-border"
      content-class="border-radius-12 clear-border"
      footer-class="clear-border d-block px-0 py-0"
    >
      <template #modal-header>
        <div
          class="close-modal-icon ml-auto"
          style="cursor: pointer"
          @click="closeModal()"
        >
          <svg
            width="12"
            height="11"
            viewbox="0 0 12 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.04883 9.1811C0.737793 9.49213 0.731445 10.0444 1.05518 10.3681C1.38525 10.6918 1.9375 10.6855 2.24219 10.3808L6 6.62299L9.75146 10.3745C10.0688 10.6918 10.6147 10.6918 10.9385 10.3681C11.2622 10.038 11.2622 9.49848 10.9448 9.1811L7.19336 5.42963L10.9448 1.67182C11.2622 1.35444 11.2686 0.808539 10.9385 0.484808C10.6147 0.161078 10.0688 0.161078 9.75146 0.47846L6 4.22993L2.24219 0.47846C1.9375 0.167425 1.37891 0.15473 1.05518 0.484808C0.731445 0.808539 0.737793 1.36713 1.04883 1.67182L4.80029 5.42963L1.04883 9.1811Z"
              fill="#818181"
            ></path>
          </svg>
        </div>
      </template>
      <template #default>
        <div class="d-flex align-items-start">
          <div class="profile-image__wrapper">
            <div class="profile-image mr-29 mb-12 no-avarta">
              <div
                v-if="!hasAvatar"
                class="profile-image__text f-600 fs-20 lh-14 cl-ffffff"
                >{{ $utils.string.getFirstChar(displayName) }}</div
              >
              <div v-if="hasAvatar" class="profile-image__img"
                ><img class="profile-image__preview" :src="displayUser.avatar"
              /></div>
              <div
                class="profile-image__input-file"
                @click.self="openProfileImagePicker"
              >
                <input
                  id="profileUpload"
                  ref="profileUploadRef"
                  class="upload-file"
                  style="display: none"
                  type="file"
                  accept="image/*"
                  @change="previewImage"
                />
              </div>
              <label
                v-if="isMyPage"
                class="profile-image__tool camera-icon"
                style="cursor: pointer"
                @click.prevent="openProfileImagePicker"
              >
                <svg
                  width="28"
                  height="28"
                  viewbox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="14" cy="14" r="14" fill="white"></circle>
                  <path
                    d="M13.9932 28C21.6665 28 28 21.6665 28 13.9932C28 6.33349 21.653 0 13.9797 0C6.31996 0 0 6.33349 0 13.9932C0 21.6665 6.33349 28 13.9932 28ZM7.87627 20.2997C6.37409 20.2997 5.58917 19.5283 5.58917 18.0532V10.7724C5.58917 9.27018 6.37409 8.51232 7.87627 8.51232H9.51377C10.0416 8.51232 10.2175 8.40406 10.5558 8.06573L11.1107 7.47028C11.4625 7.07782 11.8415 6.90188 12.5317 6.90188H15.4007C16.1044 6.90188 16.4698 7.09135 16.8217 7.47028L17.3765 8.06573C17.7148 8.41759 17.8908 8.51232 18.4321 8.51232H20.0967C21.5853 8.51232 22.3838 9.27018 22.3838 10.7724V18.0532C22.3838 19.5283 21.5853 20.2997 20.0967 20.2997H7.87627ZM13.9932 18.4321C16.2668 18.4321 18.0667 16.6593 18.0667 14.3451C18.0667 12.0851 16.2668 10.2581 13.9932 10.2581C11.7332 10.2581 9.90623 12.0851 9.90623 14.3451C9.90623 16.6187 11.7332 18.4321 13.9932 18.4321ZM19.5283 12.4911C20.0561 12.4911 20.4891 12.0715 20.4756 11.5302C20.4756 11.0024 20.0561 10.5694 19.5283 10.5694C18.9869 10.5694 18.5539 11.0024 18.5539 11.5302C18.5539 12.0715 18.9869 12.4911 19.5283 12.4911ZM13.9932 17.0382C12.5046 17.0382 11.3001 15.8473 11.3001 14.3451C11.3001 12.8429 12.5046 11.652 13.9932 11.652C15.4683 11.652 16.6728 12.8565 16.6728 14.3451C16.6728 15.8473 15.4683 17.0382 13.9932 17.0382Z"
                    fill="#1C1C1E"
                  ></path>
                </svg>
              </label>
            </div>
            <label
              v-if="isMyPage"
              class="fs-16 cl-4c6573"
              style="border-bottom: 1px solid; cursor: pointer"
              @click.prevent="openProfileImagePicker"
              >画像を設定</label
            >
          </div>
          <div class="profile-image__text">
            <div class="fs-24 lh-21 cl-1c1c1e f-600">
              {{ displayName }}
            </div>
            <div class="fs-16 lh-12 cl-798b96 mt-5">
              {{ userDisplayName }}
            </div>
            <div class="fs-16 lh-21 cl-1c1c1e mt-10" v-html="userProfile">
            </div>
            <div v-if="isMyPage" class="mt-20">
              <div
                class="fs-16 lh-21 cl-0066cc"
                style="cursor: pointer; text-decoration: underline"
                @click="goToUserActivity()"
              >
                活動履歴
              </div>
            </div>
          </div>
        </div>
        <user-confirm-delete-profile-modal
          @ok="deleteImage"
        ></user-confirm-delete-profile-modal>
      </template>
    </b-modal>
    <b-modal
      :id="'loading-modal' + modalIdKey"
      hide-footer
      hide-header
      no-close-on-backdrop
      scrollable
      centered
      modal-class="modal-global layout-modal-320"
      header-class="w-100 clear-border pb-0 pt-19 px-18"
      body-class="text-left px-33 pt-31 pb-45 clear-border"
      content-class="border-radius-12 clear-border"
      footer-class="clear-border d-block px-0 py-0"
    >
      <template #default>
        <div class="text-center">
          <div class="loading">
            <div class="lds-spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div class="fs-14 lh-21 cl-1f3e50 mt-21">{{ loadingText }}</div>
        </div>
      </template>
    </b-modal>
    <b-modal
      :id="'change-profile-modal' + modalIdKey"
      hide-header
      hide-footer
      no-close-on-backdrop
      scrollable
      centered
      modal-class="modal-global layout-modal-320"
      header-class="w-100 clear-border pb-0 pt-19 px-18"
      body-class="text-left px-16 pt-32 pb-32 clear-border"
      content-class="border-radius-12 clear-border"
      footer-class="clear-border d-block px-0 py-0"
    >
      <template #default="{ cancel }">
        <div class="text-center">
          <div class="fs-14 lh-21 cl-1f3e50 f-600"
            >現在の設定画像を変更しますか？</div
          >
          <div class="profile-image__img mt-27 mx-auto"
            ><img class="profile-image__preview" :src="displayUser.avatar"
          /></div>
          <div class="fs-14 lh-21 mt-36"
            >一度変更すると元の画像に戻すことはできません</div
          >
        </div>
        <div class="form-button-custom w-100 mt-21">
          <div
            class="btn d-flex align-items-center justify-content-center border-radius-20 py-9 fs-14 btn-primary btn-block border-radius-20 py-9 fs-14"
            @click="$refs.profileChangeRef && $refs.profileChangeRef.click()"
            >他の写真に変更する
            <div
              class="profile-image__input-file"
              style="width: 100%; height: 100%"
            >
              <input
                id="profileUpload"
                ref="profileChangeRef"
                class="upload-file"
                style="width: 100%; height: 100%; display: none"
                type="file"
                title=" "
                accept="image/*"
                @change="previewImage"
              />
            </div>
          </div>
        </div>
        <div class="form-button-custom w-100 mt-20">
          <b-button
            class="d-flex align-items-center justify-content-center border-radius-20 py-9 fs-14"
            block
            variant="outline-primary"
            @click="resetImage"
            >現在の写真を削除する</b-button
          >
        </div>
        <div class="form-button-custom w-100 mt-20">
          <b-button
            class="d-flex align-items-center justify-content-center border-radius-20 py-9 fs-14"
            block
            variant="secondary"
            @click="cancel()"
            >キャンセル</b-button
          >
        </div>
      </template>
    </b-modal>
    <b-modal
      :id="'crop-image-modal' + modalIdKey"
      no-close-on-backdrop
      scrollable
      centered
      modal-class="modal-global layout-modal-640"
      header-class="w-100 clear-border pb-0 pt-19 px-18"
      body-class="text-left px-0 pb-0 clear-border"
      content-class="border-radius-12 clear-border"
      footer-class="clear-border d-block px-0 py-0"
    >
      <template #modal-header>
        <div
          class="close-modal-icon ml-auto"
          style="cursor: pointer"
          @click="cancelEdit"
        >
          <svg
            width="12"
            height="11"
            viewbox="0 0 12 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.04883 9.1811C0.737793 9.49213 0.731445 10.0444 1.05518 10.3681C1.38525 10.6918 1.9375 10.6855 2.24219 10.3808L6 6.62299L9.75146 10.3745C10.0688 10.6918 10.6147 10.6918 10.9385 10.3681C11.2622 10.038 11.2622 9.49848 10.9448 9.1811L7.19336 5.42963L10.9448 1.67182C11.2622 1.35444 11.2686 0.808539 10.9385 0.484808C10.6147 0.161078 10.0688 0.161078 9.75146 0.47846L6 4.22993L2.24219 0.47846C1.9375 0.167425 1.37891 0.15473 1.05518 0.484808C0.731445 0.808539 0.737793 1.36713 1.04883 1.67182L4.80029 5.42963L1.04883 9.1811Z"
              fill="#818181"
            ></path>
          </svg>
        </div>
      </template>
      <template #default>
        <div class="profile-image__preview-cropper">
          <cropper
            ref="previewImageCropper"
            class="preview-image-cropper"
            :src="profilePreviewImageEdit"
            :stencil-size="{ width: 295, height: 295 }"
            :stencil-props="{ handlers: {}, resizable: false, aspectRatio: 1 }"
            :default-size="defaultCropSize"
            :stencil-component="circleStencil"
          ></cropper>
          <div
            v-if="isImageOverSize"
            class="oversize-notice d-flex align-items-center justify-content-center"
          >
            <div class="text-center">
              <div class="title cl-0000 f-700"
                >この画像はアップロードできません</div
              >
              <div class="supplement cl-000000 f-400"
                >画像は容量10mbまででご準備ください</div
              >
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <div class="pl-30 pr-15 py-18">
          <div class="row align-items-center">
            <div class="col-8 text-right">
              <div
                class="fs-18 cl-000000"
                style="cursor: pointer"
                @click="cancelEdit"
                >キャンセル</div
              >
            </div>
            <div class="col-4 text-right">
              <div class="form-button-custom w-100">
                <b-button
                  class="d-flex align-items-center justify-content-center border-radius-100 py-9 fs-18"
                  block
                  variant="primary"
                  @click="submitCropModal"
                  >{{ isImageOverSize ? 'やり直す' : 'OK' }}</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-facing-decorator'
import { Action, State, namespace } from 'vuex-facing-decorator'
import type { User } from '@/model/user/schema'
import UserConfirmDeleteProfileModal from '@/components/domain/user/UserConfirmDeleteProfileModal.vue'
import { CircleStencil, Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

const AuthStore = namespace('auth')
const UserStore = namespace('users')

@Component({
  components: {
    cropper: Cropper,
    'user-confirm-delete-profile-modal': UserConfirmDeleteProfileModal
  }
})
export default class UserProfileModal extends Vue {
  $refs!: {
    profileChangeRef: any
    profileUploadRef: any
  }
  @AuthStore.Getter currentUser: User
  @AuthStore.Action updateUser: (user: User) => void
  @Action toggleUserHeader
  @Action toggleSideBarContent
  @Action toggleNavigationBar
  @UserStore.Action updateImageProfile
  @UserStore.Action deleteImageProfile
  @State isShowUserHeader
  @State currentSkill

  @Prop({ default: false }) isMyPage: boolean
  @Prop({ default: '' }) modalKey: string
  @Prop({}) user: User

  private isDeleting: boolean = false
  //@ts-ignore
  profilePreviewImage: string = ''
  profilePreviewImageEdit: string = ''
  profilePreviewImageCrop: string = ''
  isUploaded: boolean = false
  isImageOverSize: boolean = false
  profileModalVisible: boolean = false
  profilePreviewImageConordinates: any = {}

  get displayUser(): User {
    return this.isMyPage ? this.currentUser : this.user
  }

  get modalIdKey(): string {
    if (this.isMyPage) return ''
    return `${this.user?.id || ''}${this.modalKey}`
  }

  get userDisplayName(): string {
    if (this.isMyPage) {
      return `${this.displayUser.name}@${this.displayUser.company_name}`
    } else {
      return `${this.displayUser.name}`
    }
  }

  get userProfile(): string | undefined {
    return this.displayUser.profile?.replace(/\n/g, '<br>')
  }

  public get displayName(): string {
    return this.displayUser.name
  }

  get hasAvatar(): boolean {
    return !!this.displayUser.avatar || this.isUploaded
  }

  get circleStencil() {
    return CircleStencil
  }

  public showModal() {
    this.profileModalVisible = true
  }

  get loadingText(): string {
    return this.isDeleting ? '削除中です...' : 'アップロード中です...'
  }

  protected closeModal() {
    this.$emit('cancel')
    // this.resetForm();
    this.profileModalVisible = false
  }

  goToUserActivity() {
    if (!this.isMyPage) return

    const publicId = this.currentUser.userPublicId
    if (!publicId) return

    this.$router.push({ name: 'UserActivity', params: { userHash: publicId } })
    this.closeModal()
  }

  deleteImage() {
    if (!this.isMyPage) {
      return
    }

    this.$bvModal.hide('confirm-delete-profile-modal' + this.modalIdKey)
    this.$bvModal.hide('change-profile-modal' + this.modalIdKey)
    this.$bvModal.show('loading-modal' + this.modalIdKey)
    this.isDeleting = true
    this.deleteImageProfile().then((res) => {
      if (res.success) {
        this.currentUser.avatar = ''
        this.updateUser({
          ...this.currentUser,
          avatar: ''
        })
        this.isUploaded = false
      }
      this.isDeleting = false
      this.$bvModal.hide('loading-modal' + this.modalIdKey)
    })
  }

  protected uploadImage(imageFile: Blob) {
    if (!this.isMyPage) {
      return
    }

    if (!imageFile) return
    const payload = { image: imageFile }
    return this.updateImageProfile(payload)
      .then((res) => {
        if (res.success) {
          this.updateUser({
            ...this.currentUser,
            avatar: res.imagePath
          })
          this.resetUploadedImage()
        }
      })
      .finally(() => {
        this.$bvModal.hide('loading-modal' + this.modalIdKey)
        this.$bvModal.hide('crop-image-modal' + this.modalIdKey)
        this.$bvModal.hide('change-profile-modal' + this.modalIdKey)
        this.$bvModal.hide('profile-modal' + this.modalIdKey)
      })
  }

  protected previewImage(event) {
    if (!this.isMyPage) {
      return
    }

    let reader = new FileReader()
    let inputTarget = event.target
    this.isUploaded = false
    if (inputTarget.files && inputTarget.files[0]) {
      if (inputTarget.files[0].size > this.$constants.MAX_IMAGE_FILE_SIZE) {
        this.isImageOverSize = true
      }

      this.$bvModal.show('loading-modal' + this.modalIdKey)
      reader.onload = (event) => {
        // @ts-ignore
        this.profilePreviewImage = (
          event.target ? event.target.result : ''
        ) as string
        this.profilePreviewImageEdit = this.profilePreviewImage
        this.$bvModal.show('crop-image-modal' + this.modalIdKey)
        this.$bvModal.hide('loading-modal' + this.modalIdKey)
      }
      this.isUploaded = true
      reader.readAsDataURL(inputTarget.files[0])
    }
  }

  protected cropImage() {
    if (!this.isMyPage) {
      return
    }

    // @ts-ignore
    const { coordinates, canvas } = this.$refs.previewImageCropper.getResult()

    this.$bvModal.show('loading-modal' + this.modalIdKey)
    this.profilePreviewImageConordinates = coordinates
    this.profilePreviewImageCrop = canvas.toDataURL()

    canvas.toBlob((result) => {
      this.uploadImage(result)
    }, 'image/jpeg')
  }

  protected deleteCropImage() {
    this.profilePreviewImageEdit = ''
    this.$bvModal.hide('crop-image-modal' + this.modalIdKey)
  }

  protected resetImage() {
    this.resetUploadedImage()
    this.$bvModal.show('confirm-delete-profile-modal' + this.modalIdKey)
  }

  protected cancelEdit() {
    this.resetUploadedImage()
    this.$bvModal.hide('crop-image-modal' + this.modalIdKey)
  }

  protected defaultCropSize({ imageSize, visibleArea }) {
    return {
      height: (imageSize || visibleArea).height,
      width: (imageSize || visibleArea).width
    }
  }

  protected openProfileImagePicker() {
    if (!this.isMyPage) {
      return
    }

    this.$refs.profileUploadRef?.click()
  }

  protected submitCropModal() {
    if (!this.isImageOverSize) return this.cropImage()
    this.resetUploadedImage()
    this.$bvModal.hide('loading-modal' + this.modalIdKey)
    this.$bvModal.hide('crop-image-modal' + this.modalIdKey)

    this.openProfileImagePicker()
  }

  private resetUploadedImage() {
    // @ts-ignore
    if (this.$refs.profileUploadRef) this.$refs.profileUploadRef.value = null
    // @ts-ignore
    if (this.$refs.profileChangeRef) this.$refs.profileChangeRef.value = null
    this.profilePreviewImage = ''
    this.profilePreviewImageEdit = ''
    this.isUploaded = false
    this.isImageOverSize = false
  }
}
</script>

<style lang="sass" scoped></style>
